export let leaveClassNameType: Array<any> = [
  {
    name: 'Sick leave',
    className: 'sickLeave',
    key: 'sickLeave',
    code: 'SL',
    value: '',
  },
  {
    name: 'Public holiday',
    className: 'publicHoliday',
    key: 'publicHoliday',
    code: 'PH',
    value: '',
  },
  {
    name: 'Paid Holiday',
    className: 'authorisedAbsence',
    key: 'authorisedAbsence',
    code: 'AA',
    value: '',
  },
  {
    name: 'Paternity leave',
    className: 'maternityLeave',
    key: 'maternityLeave',
    code: 'ML',
    value: '',
  },
  {
    name: 'Parental leave',
    className: 'parentalLeave',
    key: 'parentalLeave',
    code: 'PL',
    value: '',
  },
  {
    name: 'Holiday',
    className: 'holiday',
    key: 'holiday',
    code: 'H',
    value: '',
  },
  {
    name: 'Rtt/ADV days',
    className: 'rttAdv',
    key: 'rttAdv',
    code: 'RTT',
    value: '',
  },
  {
    name: 'Forwarded Leaves',
    className: 'forwardedLeave',
    key: 'forwardedLeave',
    code: 'FL',
    value: '',
  },
  {
    name: 'Unauthorised absence',
    className: 'unauthorisedAbsence',
    key: 'unauthorisedAbsence',
    code: 'UA',
    value: '',
  },
  {
    name: 'Force majeure',
    className: 'forceMajeure',
    key: 'forceMajeure',
    code: 'FM',
    value: '',
  },
  { name: 'Other', className: 'other', key: 'other', code: 'O', value: '' },
  {
    name: 'Compensation Leave',
    className: 'compensationLeave',
    key: 'compensationLeave',
    code: 'CL',
    value: '',
  },
];

export let leaveBalence: Array<any> = [
  {
    name: 'Paid Holiday',
    className: 'authorisedAbsence',
    key: 'authorisedAbsence',
    code: 'AA',
    value: '',
  },
  {
    name: 'Rtt/ADV days',
    className: 'rttAdv',
    key: 'rttAdv',
    code: 'RTT',
    value: '',
  },
  {
    name: 'Compensation Leave',
    className: 'compensationLeave',
    key: 'compensationLeave',
    code: 'CL',
    value: '',
  },
  {
    name: 'Forwarded Leaves',
    className: 'forwardedLeave',
    key: 'forwardedLeave',
    code: 'FL',
    value: '',
  },
  {
    name: 'Paternity leave',
    className: 'maternityLeave',
    key: 'maternityLeave',
    code: 'ML',
    value: '',
  },
  {
    name: 'Parental leave',
    className: 'parentalLeave',
    key: 'parentalLeave',
    code: 'PL',
    value: '',
  },
  {
    name: 'Sick leave',
    className: 'sickLeave',
    key: 'sickLeave',
    code: 'SL',
    value: '',
  },
  {
    name: 'Sick leave WithOut Cert',
    className: 'sickLeaveWOCert',
    key: 'sickLeaveWOCert',
    code: 'SC',
    value: '',
  },
];
